import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconHorizontalRuleComponent } from "./med-icon-horizontal-rule.component";

@NgModule({
  declarations: [
    MedIconHorizontalRuleComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconHorizontalRuleComponent,
  ],
})
export class MedIconHorizontalRuleModule { }
